import { Route, Switch, Redirect } from "react-router-dom";
import React from 'react';
import constant from "./constant";
import { getDefaultAuthedRoute, getSessionStorage, getStorage, isVesselCrew, setSessionStorage } from "./utils";
import { v3_profile_detail } from './actions/v3/user';
// import FourZeroFour from "./components/common/404";
import Login from './pages/auth/login'
import ForgotPassword from './pages/auth/forgotPassword'
import Lock from './pages/auth/lock'
import Header from './components/common/header'
import HorizontalSideBar from './components/common/horizontalSidebar'
import InProgress from './components/common/inProgress'
import Footer from './components/common/footer'

import Dashboard from './pages/DashBoard'
import ProfileUpdate from './pages/auth/updateProfile'
import GlobalSettingUpdate from './pages/Administration/globalSetting/index'




// Administrator

import AddUser from './pages/Administration/users/add'
import EditUser from './pages/Administration/users/edit'
import ListUser from './pages/Administration/users/list'
import AddRole from './pages/Administration/role/add'
import EditRole from './pages/Administration/role/edit'
import ListRole from './pages/Administration/role/list'

import AddDesignation from './pages/Administration/designations/add'
import EditDesignation from './pages/Administration/designations/edit'
import ListDesignation from './pages/Administration/designations/list'

import ListModule from './pages/Administration/module/list'
import AssignModule from './pages/Administration/module/roles_assign'
import ActivityLogs from './pages/Administration/logs/list'

// Administrator

// Mail Box
import MailBox from './pages/MailBox/index'
import MailBoxConfigure from './pages/MailBox/configure'
import CrewMailBox from './pages/MailBox/crew'
import Training from './pages/Training'
import SMS from './pages/SMS'
import MicrosoftAuthCallBack from './pages/MailBox/microsoftAuthCallBack'


// Mail Box


// Master Data


import AddStateMasterData from './pages/MasterData/State/add'
import ListStateMasterData from './pages/MasterData/State/list'
import EditStateMasterData from './pages/MasterData/State/edit'

import AddDistrictMasterData from './pages/MasterData/District/add'
import ListDistrictMasterData from './pages/MasterData/District/list'
import EditDistrictMasterData from './pages/MasterData/District/edit'

import AddLeaveTypeMasterData from './pages/MasterData/LeaveType/add'
import ListLeaveTypeMasterData from './pages/MasterData/LeaveType/list'
import EditLeaveTypeMasterData from './pages/MasterData/LeaveType/edit'

import AddExpenseTypeMasterData from './pages/MasterData/ExpenseType/add'
import ListExpenseTypeMasterData from './pages/MasterData/ExpenseType/list'
import EditExpenseTypeMasterData from './pages/MasterData/ExpenseType/edit'

import AddYardMasterData from './pages/ProjectsAndVessels/Yard/add'
import ListYardMasterData from './pages/ProjectsAndVessels/Yard/list'
import EditYardMasterData from './pages/ProjectsAndVessels/Yard/edit'

import AddShipMasterData from './pages/ProjectsAndVessels/Ship/add'
import ListShipMasterData from './pages/ProjectsAndVessels/Ship/list'
import EditShipMasterData from './pages/ProjectsAndVessels/Ship/edit'

import AddBuilderMasterData from './pages/MasterData/Builder/add'
import ListBuilderMasterData from './pages/MasterData/Builder/list'
import EditBuilderMasterData from './pages/MasterData/Builder/edit'


import AddShipyardMasterData from './pages/MasterData/ShipYard/add'
import ListShipyardMasterData from './pages/MasterData/ShipYard/list'
import EditShipyardMasterData from './pages/MasterData/ShipYard/edit'


import AddSubContractorMasterData from './pages/MasterData/SubContractor/add'
import ListSubContractorMasterData from './pages/MasterData/SubContractor/list'
import EditSubContractorMasterData from './pages/MasterData/SubContractor/edit'

import AddProjectLocationMasterData from './pages/MasterData/ProjectLocation/add'
import ListProjectLocationMasterData from './pages/MasterData/ProjectLocation/list'
import EditProjectLocationMasterData from './pages/MasterData/ProjectLocation/edit'

import AddSiteLocationMasterData from './pages/MasterData/SiteLocation/add'
import ListSiteLocationMasterData from './pages/MasterData/SiteLocation/list'
import EditSiteLocationMasterData from './pages/MasterData/SiteLocation/edit'

import AddScheduleCategoryMasterData from './pages/MasterData/ScheduleCategory/add'
import listScheduleCategoryMasterData from './pages/MasterData/ScheduleCategory/list'
import editScheduleCategoryMasterData from './pages/MasterData/ScheduleCategory/edit'

import AddCategoryEventMasterData from './pages/MasterData/EventType/add'
import ListCategoryEventMasterData from './pages/MasterData/EventType/list'
import EditCategoryEventMasterData from './pages/MasterData/EventType/edit'

import AddDocumentTypeMasterData from './pages/MasterData/DocumentType/add'
import ListDocumentTypeMasterData from './pages/MasterData/DocumentType/list'
import EditDocumentTypeMasterData from './pages/MasterData/DocumentType/edit'



import AddCompanyMasterData from './pages/MasterData/Company/add'
import ListCompanyMasterData from './pages/MasterData/Company/list'
import EditCompanyMasterData from './pages/MasterData/Company/edit'

import AddChannelMasterData from './pages/MasterData/Channel/add'
import ListChannelMasterData from './pages/MasterData/Channel/list'
import EditChannelMasterData from './pages/MasterData/Channel/edit'


import AddPlanTypeMasterData from './pages/MasterData/PlanType/add'
import ListPlanTypeMasterData from './pages/MasterData/PlanType/list'
import EditPlanTypeMasterData from './pages/MasterData/PlanType/edit'

import AddRemarkOptionMasterData from './pages/MasterData/RemarkOption/add'
import ListRemarkOptionMasterData from './pages/MasterData/RemarkOption/list'
import EditRemarkOptionMasterData from './pages/MasterData/RemarkOption/edit'

// Master Data


// Projects and Vessels
import AddShipTypeMasterData from './pages/MasterData/ShipType/add'
import ListShipTypeMasterData from './pages/MasterData/ShipType/list'
import EditShipTypeMasterData from './pages/MasterData/ShipType/edit'

import AddShipOwnerMasterData from './pages/ProjectsAndVessels/ShipOwner/add'
import ListShipOwnerMasterData from './pages/ProjectsAndVessels/ShipOwner/list'
import EditShipOwnerMasterData from './pages/ProjectsAndVessels/ShipOwner/edit'
import AssignProjectToVessel from './pages/ProjectsAndVessels/Projects/assignShip'

import AddProject from './pages/ProjectsAndVessels/Projects/add'
import ListProject from './pages/ProjectsAndVessels/Projects/list'
import EditProject from './pages/ProjectsAndVessels/Projects/edit'

import AddCategoryMasterData from './pages/MasterData/Category/add'
import ListCategoryMasterData from './pages/MasterData/Category/list'
import EditCategoryMasterData from './pages/MasterData/Category/edit'

// Projects and Vessels


// Leave

import LeaveApply from './pages/leave/apply'
import LeaveEdit from './pages/leave/edit'

import AppliedLeave from './pages/leave/applied'
import LeaveApplications from './pages/leave/applications'

// Leave

// Expense
import SubmitNewExpense from './pages/expense/submitExpense'
import EditExpense from './pages/expense/editExpense'
import SubmittedExpense from './pages/expense/submittedExpenses'
import ExpenseApplications from './pages/expense/applications'
// Expense

// Appraisal
import SubmitAppraisalForm from './pages/Appraisal/add'
import SubmittedAppraisalForm from './pages/Appraisal/list'



// Appraisal

// Schedule
import SchedulePreview from './pages/Schedule/preview'
import AddScheduleEvent from './pages/Schedule/add'

// Schedule


// Document
import ProjectDocumentList from './pages/Document/projectWiseDocumentCount'
import ShipWiseDocumentList from './pages/Document/shipWiseDocumentList'

// Document

// Checklist
import ProductionCreate from './pages/Production/index'
import ProductionReports from './pages/Production/reports'


import CreateNewBuildingPreLaunchingCheckList from './pages/Production/Create/NewBuildingPreLaunchingCheckList'
import CreateNewBuildingPreDeliveryCheckList from './pages/Production/Create/NewBuildingPreDeliveryCheckList'
import CreateNewBuildingPreSeaTrialCheckList from './pages/Production/Create/NewBuildingPreSeaTrialCheckList'
import CreateNewBuildingFinalDeliveryDocumentChecksheet from './pages/Production/Create/NewBuildingFinalDeliveryDocumentChecksheet'
import CreateNewBuildingBlockInspectionStatus from './pages/Production/Create/NewBuildingBlockInspectionStatus'
import CreateNewBuildingConfirmationOfVesselCompletionAndDelivery from './pages/Production/Create/NewBuildingConfirmationOfVesselCompletionAndDelivery'
import CreateNewBuildingDailyInspectionReport from './pages/Production/Create/NewBuildingDailyInspectionReport'
import CreateNewBuildingNCRIndex from './pages/Production/Create/NewBuildingNCRIndex'
import CreateWeeklyTimesheet from './pages/Production/Create/WeeklyTimesheet'
import CreateNewBuildingNCR from './pages/Production/Create/NewBuildingNCR'
import CreateNewBuildingOwnerDefectReport from './pages/Production/Create/OwnerDefectReport'

import SubmittedNewBuildingOwnerDefectReport from './pages/Production/Submitted/OwnerDefectReport'




import ConfigureNewBuildingPreLaunchingCheckList from './pages/Production/Configure/NewBuildingPreLaunchingCheckList'
import SubmittedNewBuildingPreLaunchingCheckList from './pages/Production/Submitted/NewBuildingPreLaunchingCheckList'

import ConfigureNewBuildingPreDeliveryCheckList from './pages/Production/Configure/NewBuildingPreDeliveryCheckList'
import SubmittedNewBuildingPreDeliveryCheckList from './pages/Production/Submitted/NewBuildingPreDeliveryCheckList'

import ConfigureNewBuildingPreSeaTrialCheckList from './pages/Production/Configure/NewBuildingPreSeaTrialCheckList'
import SubmittedNewBuildingPreSeaTrialCheckList from './pages/Production/Submitted/NewBuildingPreSeaTrialCheckList'

import ConfigureNewBuildingFinalDeliveryDocumentChecksheet from './pages/Production/Configure/NewBuildingFinalDeliveryDocumentChecksheet'
import SubmittedNewBuildingFinalDeliveryDocumentChecksheet from './pages/Production/Submitted/NewBuildingFinalDeliveryDocumentChecksheet'

import SubmittedNewBuildingBlockInspectionStatus from './pages/Production/Submitted/NewBuildingBlockInspectionStatus'

import SubmittedNewBuildingConfirmationOfVesselCompletionAndDelivery from './pages/Production/Submitted/NewBuildingConfirmationOfVesselCompletionAndDelivery'

import SubmittedNewBuildingDailyInspectionReport from './pages/Production/Submitted/NewBuildingDailyInspectionReport'


import SubmittedNewBuildingNCRIndex from './pages/Production/Submitted/NewBuildingNCRIndex'

import SubmittedWeeklyTimeSheet from './pages/Production/Submitted/WeeklyTimeSheet'

import SubmittedNewBuildingNCR from './pages/Production/Submitted/NewBuildingNCR'


import BlockInspectionStatusMasterlist from './pages/Production/pending/block-inspection-status-masterlist';
import VesselCompletionAndDelivery from './pages/Production/pending/confirmation-of-vessel-completion-and-delivery';
import DailyInspectionReport from './pages/Production/pending/daily-inspection-report';
import NonConformityReport from './pages/Production/pending/non-conformity-report';
import NonConformityReportIndex from './pages/Production/pending/non-conformity-report-index';
import OwnerDefectReport from './pages/Production/pending/owner-defect-report';
import WeeklyTimeSheet from './pages/Production/pending/weekly-time-sheet';



import SiteQueryReportIndex from './pages/SiteManagement/pending/SiteQueryReportIndex';
import SiteAuditIndex from './pages/SiteManagement/pending//SiteAuditIndex';
import VOIndexRegister from './pages/SiteManagement/pending/VOIndexRegister';
import CustomerPropertyInventory from './pages/SiteManagement/pending/CustomerPropertyInventory';
import SiteQueryForm from './pages/SiteManagement/pending/SiteQueryForm';
import ShipyardEvaluationOfShipyardPerformance from './pages/SiteManagement/pending/ShipyardEvaluationOfShipyardPerformance';
import VariationOrderForm from './pages/SiteManagement/pending/VariationOrderForm';


import SiteManagement from './pages/SiteManagement/index';

import CreateNewBuildingSiteQueryReportIndex from './pages/SiteManagement/Create/NewBuildingSiteQueryReportIndex'
import SubmittedNewBuildingSiteQueryReportIndex from './pages/SiteManagement/Submitted/NewBuildingSiteQueryReportIndex'

import CreateNewBuildingSiteQueryForm from './pages/SiteManagement/Create/NewBuildingSiteQueryForm'
import SubmittedNewBuildingSiteQueryForm from './pages/SiteManagement/Submitted/NewBuildingSiteQueryForm'

import CreatePotentialVariationOrderForm from './pages/SiteManagement/Create/PotentialVariationOrderForm'
import SubmittedPotentialVariationOrderForm from './pages/SiteManagement/Submitted/PotentialVariationOrderForm'

import CreateCustomerPropertyInventoryForm from './pages/SiteManagement/Create/CustomerPropertyInventory'
import SubmittedCustomerPropertyInventoryForm from './pages/SiteManagement/Submitted/CustomerPropertyInventory'

import CreateSiteAuditIndex from './pages/SiteManagement/Create/SiteAuditIndex'

import CreatePotentialVariationOrderIndexRegisterForm from './pages/SiteManagement/Create/PotentialVariationOrderIndexRegisterForm'

import CreateShipYardEvaluationPerformanceForm from './pages/SiteManagement/Create/ShipYardEvaluationPerformance'
import SubmittedShipYardEvaluationPerformanceForm from './pages/SiteManagement/Submitted/ShipyardEvaluationPerformance'

import CreateFatReportForm from './pages/SiteManagement/Create/FatReport'
import SubmittedFatReportForm from './pages/SiteManagement/Submitted/FatReport'

import CreateBiWeeklyReportForm from './pages/SiteManagement/Create/BiWeeklyReportForm'
import SubmittedBiWeeklyForm from './pages/SiteManagement/Submitted/BiWeeklyReport'

import CreateMonthlyReportForm from './pages/SiteManagement/Create/MonthlyReport'
import SubmittedMonthlyReportForm from './pages/SiteManagement/Submitted/MonthlyReport'


import CreateDrawingListForm from './pages/SiteManagement/Create/DrawingList'
import SubmittedDrawingListForm from './pages/SiteManagement/Submitted/DrawingList'

import CreateListofRefereceBookAndPublicationForm from './pages/SiteManagement/Create/ListofRefereceBookAndPublication'
import SubmittedListofRefereceBookAndPublicationForm from './pages/SiteManagement/Submitted/ListofRefereceBookAndPublication'

import CreateOwnerNcrForm from './pages/SiteManagement/Create/OwnerNcr'
import SubmittedOwnerNcrForm from './pages/SiteManagement/Submitted/OwnerNcr'

// Checklist


// Plan Approval
import PlanApprovalIndex from './pages/PlanApproval/index'
import PlanApprovalCreate from './pages/PlanApproval/create'
import PlanApprovalProject from './pages/PlanApproval/project'
import PlanApprovalDetail from './pages/PlanApproval/detail'
// Plan Approval


// FAT
import FATIndex from './pages/FAT/index'
import FATProject from './pages/FAT/project'
import FATCreate from './pages/FAT/create'
import FATEdit from './pages/FAT/edit'
import FATDetails from './pages/FAT/detail'


// FAT


// NCR
import NCRIndex from './pages/NCR/index'
import NCRList from './pages/NCR/list'
import NCRDetail from './pages/NCR/detail'
import NCRCreate from './pages/NCR/create'
import NCRCreateComment from './pages/NCR/newComment'


// NCR



// Inspection
import InspectionIndex from './pages/Inspection/index'
import InspectionProject from './pages/Inspection/project'
import InspectionCreate from './pages/Inspection/create'
import InspectionEdit from './pages/Inspection/edit'

// Inspection



// Final Drawing
import FinalDrawingIndex from './pages/FinalDrawing/index'
import FinalDrawingDetail from './pages/FinalDrawing/detail'
import CreateFinalDrawing from './pages/FinalDrawing/create'
import EditFinalDrawing from './pages/FinalDrawing/edit'

// Final Drawing


// Guaranty Claim

import ProjectGuarantyClaimCount from './pages/GuaranteeClaims/projectWiseClaimCount'
import CreateGuarantyClaim from './pages/GuaranteeClaims/add'
import ShipWisrClaimList from './pages/GuaranteeClaims/shipWiseClaimList'


// Guaranty Claim



// Attendance
import MyAttendance from './pages/Attendance/myAttendance'
import AttendanceProject from './pages/Attendance/projectList'
import CreateAttendance from './pages/Attendance/create'
import AttendanceMonthlyReport from './pages/Attendance/monthlyReport'
import UserAttendanceMonthlyReport from './pages/Attendance/userMonthlyReport'



// Attendance



import Manual from './pages/Manual'
import Logout from './pages/auth/logout'
import ResetPasswordPage from "./pages/auth/resetPassword";
import SharedDocument from "./pages/Share/index";
import AddDocument from "./pages/Document/add";
import EditDocument from "./pages/Document/edit";
import PermissionDenied from "./components/common/permissionDenied";




const Router = (props) => {
    return (
        <React.Fragment>
            <Switch>
                <NonAuthedRoute exact={true} hideHeader={true} hideFooter={true} hideSidebar={false} path={constant.nonAuthedcomponent.login.url} component={Login} />
                <NonAuthedRoute exact={true} hideHeader={true} hideFooter={true} hideSidebar={false} path={constant.nonAuthedcomponent.lockScreen.url} component={Lock} />
                <NonAuthedRoute exact={true} hideHeader={true} hideFooter={true} hideSidebar={false} path={constant.nonAuthedcomponent.forgotPassword.url} component={ForgotPassword} />
                <NonAuthedRoute exact={true} hideHeader={true} hideFooter={true} hideSidebar={false} path={constant.nonAuthedcomponent.resetPassword.url} component={ResetPasswordPage} />

                {/* Plain Route: NonAuthedRoute bounces logged-in users to the dashboard,
                    which would break a share link opened by someone already signed in. */}
                <Route exact={true} path={constant.nonAuthedcomponent.sharedDocument.url} component={SharedDocument} />


                <PrivateRoute exact={true} denyVesselCrew={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.dashboard.url} component={Dashboard} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.updateProfile.url} component={ProfileUpdate} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.updateGlobalSetting.url} component={GlobalSettingUpdate} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} allowVesselCrew path={constant.Authedcomponent.mailBox.url} component={MailBox}
                    onlineUsers={props.onlineUsers}
                />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.mailBoxConfigure.url} component={MailBoxConfigure} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.crewMailBox.url} component={CrewMailBox} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.training.url} component={Training} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.sms.url} component={SMS} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.microsoftAuthCallback.url} component={MicrosoftAuthCallBack} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.addUser.url} component={AddUser} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listUser.url} component={ListUser} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editUser.url} component={EditUser} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.addRole.url} component={AddRole} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editRole.url} component={EditRole} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listRole.url} component={ListRole} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.addDesignation.url} component={AddDesignation} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editDesignation.url} component={EditDesignation} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listDesignation.url} component={ListDesignation} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listModules.url} component={ListModule} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.assignModules.url} component={AssignModule} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createStateMasterData.url} component={AddStateMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listStateMasterData.url} component={ListStateMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editStateMasterData.url} component={EditStateMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createDistrictMasterData.url} component={AddDistrictMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listDistrictMasterData.url} component={ListDistrictMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editDistrictMasterData.url} component={EditDistrictMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createLeaveTypeMasterData.url} component={AddLeaveTypeMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listLeaveTypeMasterData.url} component={ListLeaveTypeMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editLeaveTypeMasterData.url} component={EditLeaveTypeMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createExpenseTypeMasterData.url} component={AddExpenseTypeMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listExpenseTypeMasterData.url} component={ListExpenseTypeMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editExpenseTypeMasterData.url} component={EditExpenseTypeMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createYardMasterData.url} component={AddYardMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listYardMasterData.url} component={ListYardMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editYardMasterData.url} component={EditYardMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createShipOwnerMasterData.url} component={AddShipOwnerMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listShipOwnerMasterData.url} component={ListShipOwnerMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editShipOwnerMasterData.url} component={EditShipOwnerMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createShipMasterData.url} component={AddShipMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listShipMasterData.url} component={ListShipMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editShipMasterData.url} component={EditShipMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createBuilderMasterData.url} component={AddBuilderMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listBuilderMasterData.url} component={ListBuilderMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editBuilderMasterData.url} component={EditBuilderMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createShipYardMasterData.url} component={AddShipyardMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listShipYardMasterData.url} component={ListShipyardMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editShipYardMasterData.url} component={EditShipyardMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createShipTypeMasterData.url} component={AddShipTypeMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listShipTypeMasterData.url} component={ListShipTypeMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editShipTypeMasterData.url} component={EditShipTypeMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createCategoryMasterData.url} component={AddCategoryMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listCategoryMasterData.url} component={ListCategoryMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editCategoryMasterData.url} component={EditCategoryMasterData} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createSubContractorMasterData.url} component={AddSubContractorMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listSubContractorMasterData.url} component={ListSubContractorMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editSubContractorMasterData.url} component={EditSubContractorMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createProjectLocationMasterData.url} component={AddProjectLocationMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listProjectLocationMasterData.url} component={ListProjectLocationMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editProjectLocationMasterData.url} component={EditProjectLocationMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.assignVesselsToProject.url} component={AssignProjectToVessel} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createSiteLocationMasterData.url} component={AddSiteLocationMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listSiteLocationMasterData.url} component={ListSiteLocationMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editSiteLocationMasterData.url} component={EditSiteLocationMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createScheduleCategoryMasterData.url} component={AddScheduleCategoryMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listScheduleCategoryMasterData.url} component={listScheduleCategoryMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editScheduleCategoryMasterData.url} component={editScheduleCategoryMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createCategoryEventMasterData.url} component={AddCategoryEventMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listCategoryEventMasterData.url} component={ListCategoryEventMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editCategoryEventMasterData.url} component={EditCategoryEventMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createDocumentTypeMasterData.url} component={AddDocumentTypeMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listDocumentTypeMasterData.url} component={ListDocumentTypeMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editDocumentTypeMasterData.url} component={EditDocumentTypeMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createCompanyMasterData.url} component={AddCompanyMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listCompanyMasterData.url} component={ListCompanyMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editCompanyMasterData.url} component={EditCompanyMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createChannelMasterData.url} component={AddChannelMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listChannelMasterData.url} component={ListChannelMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editChannelMasterData.url} component={EditChannelMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createPlanTypeMasterData.url} component={AddPlanTypeMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listPlanTypeMasterData.url} component={ListPlanTypeMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editPlanTypeMasterData.url} component={EditPlanTypeMasterData} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createRemarkOptionMasterData.url} component={AddRemarkOptionMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listRemarkOptionMasterData.url} component={ListRemarkOptionMasterData} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editRemarkOptionMasterData.url} component={EditRemarkOptionMasterData} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.leaveApply.url} component={LeaveApply} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.leaveEdit.url} component={LeaveEdit} />
                <PrivateRoute exact={true} hideHeader       ={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.leaveApplied.url} component={AppliedLeave} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.leaveApplications.url} component={LeaveApplications} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewExpense.url} component={SubmitNewExpense} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editExpense.url} component={EditExpense} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.expenseList.url} component={SubmittedExpense} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.expenseApplications.url} component={ExpenseApplications} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.addProject.url} component={AddProject} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.listProject.url} component={ListProject} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editProject.url} component={EditProject} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitAppraisalForm.url} component={SubmitAppraisalForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedAppraisals.url} component={SubmittedAppraisalForm} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.schedulePreview.url} component={SchedulePreview} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.addEventSchdule.url} component={AddScheduleEvent} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.projectDocumentCount.url} component={ProjectDocumentList} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.shipDocument.url} component={ShipWiseDocumentList} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.addDocument.url} component={AddDocument} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editDocument.url} component={EditDocument} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.production.url} component={ProductionCreate} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.productionReports.url} component={ProductionReports} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingPreLaunchingCheckList.url} component={CreateNewBuildingPreLaunchingCheckList} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingPreDeliveryCheckList.url} component={CreateNewBuildingPreDeliveryCheckList} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingPreSeaTrialCheckList.url} component={CreateNewBuildingPreSeaTrialCheckList} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingFinalDeliveryDocumentChecksheet.url} component={CreateNewBuildingFinalDeliveryDocumentChecksheet} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingBlockInspectionStatus.url} component={CreateNewBuildingBlockInspectionStatus} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingConfirmationOfVesselCompletionAndDelivery.url} component={CreateNewBuildingConfirmationOfVesselCompletionAndDelivery} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingDailyInspectionReport.url} component={CreateNewBuildingDailyInspectionReport} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingNCRIndex.url} component={CreateNewBuildingNCRIndex} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitWeeklyTimesheet.url} component={CreateWeeklyTimesheet} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingNCR.url} component={CreateNewBuildingNCR} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitOwnerDefectReport.url} component={CreateNewBuildingOwnerDefectReport} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedOwnerDefectReport.url} component={SubmittedNewBuildingOwnerDefectReport} />




                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.configureNewBuildingPreLaunchingCheckList.url} component={ConfigureNewBuildingPreLaunchingCheckList} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingPreLaunchingCheckList.url} component={SubmittedNewBuildingPreLaunchingCheckList} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.configureNewBuildingPreDeliveryCheckList.url} component={ConfigureNewBuildingPreDeliveryCheckList} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingPreDeliveryCheckList.url} component={SubmittedNewBuildingPreDeliveryCheckList} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.configureNewBuildingPreSeaTrialCheckList.url} component={ConfigureNewBuildingPreSeaTrialCheckList} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingPreSeaTrialCheckList.url} component={SubmittedNewBuildingPreSeaTrialCheckList} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.configureNewBuildingFinalDeliveryDocumentChecksheet.url} component={ConfigureNewBuildingFinalDeliveryDocumentChecksheet} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingFinalDeliveryDocumentChecksheet.url} component={SubmittedNewBuildingFinalDeliveryDocumentChecksheet} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingBlockInspectionStatus.url} component={SubmittedNewBuildingBlockInspectionStatus} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingConfirmationOfVesselCompletionAndDelivery.url} component={SubmittedNewBuildingConfirmationOfVesselCompletionAndDelivery} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingDailyInspectionReport.url} component={SubmittedNewBuildingDailyInspectionReport} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingNCRIndex.url} component={SubmittedNewBuildingNCRIndex} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedWeeklyTimeSheet.url} component={SubmittedWeeklyTimeSheet} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingNCR.url} component={SubmittedNewBuildingNCR} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingBlockInspection.url} component={BlockInspectionStatusMasterlist} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingVesselConfirmation.url} component={VesselCompletionAndDelivery} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingDailyInspection.url} component={DailyInspectionReport} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingNCR.url} component={NonConformityReport} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingNCRIndex.url} component={NonConformityReportIndex} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingOwnerDefect.url} component={OwnerDefectReport} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingWeeklyTimesheet.url} component={WeeklyTimeSheet} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingSiteQueryReportIndex.url} component={SiteQueryReportIndex} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingSiteAuditIndex.url} component={SiteAuditIndex} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingVOIndexRegister.url} component={VOIndexRegister} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingCustomerPropertyInventory.url} component={CustomerPropertyInventory} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingSiteQueryForm.url} component={SiteQueryForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingShipyardevaluationofshipyardperformance.url} component={ShipyardEvaluationOfShipyardPerformance} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.pendingVariationOrderForm.url} component={VariationOrderForm} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.siteManagement.url} component={SiteManagement} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingSiteQueryReportIndex.url} component={CreateNewBuildingSiteQueryReportIndex} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingSiteQueryReportIndex.url} component={SubmittedNewBuildingSiteQueryReportIndex} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingSiteQueryForm.url} component={CreateNewBuildingSiteQueryForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingSiteQueryForm.url} component={SubmittedNewBuildingSiteQueryForm} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingPotentialVariationOrderForm.url} component={CreatePotentialVariationOrderForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingPotentialVariationOrderForm.url} component={SubmittedPotentialVariationOrderForm} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingCustomerPropertyInventoryForm.url} component={CreateCustomerPropertyInventoryForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedNewBuildingCustomerPropertyInventoryForm.url} component={SubmittedCustomerPropertyInventoryForm} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitNewBuildingSiteAuditIndex.url} component={CreateSiteAuditIndex} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitPotentialVariationOrderIndexRegister.url} component={CreatePotentialVariationOrderIndexRegisterForm} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitShipyardEvaluationPerformance.url} component={CreateShipYardEvaluationPerformanceForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedShipyardEvaluationPerformance.url} component={SubmittedShipYardEvaluationPerformanceForm} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitFatReport.url} component={CreateFatReportForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedFatReport.url} component={SubmittedFatReportForm} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitBiWeeklyReport.url} component={CreateBiWeeklyReportForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedBiWeeklyReport.url} component={SubmittedBiWeeklyForm} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitMonthlyReport.url} component={CreateMonthlyReportForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedMonthlyReport.url} component={SubmittedMonthlyReportForm} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitDrawingList.url} component={CreateDrawingListForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedDrawingList.url} component={SubmittedDrawingListForm} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitListOfReferenceBooksAndPublication.url} component={CreateListofRefereceBookAndPublicationForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedListOfReferenceBooksAndPublication.url} component={SubmittedListofRefereceBookAndPublicationForm} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submitOwnerNCR.url} component={CreateOwnerNcrForm} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.submittedOwnerNCR.url} component={SubmittedOwnerNcrForm} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.planApprovalIndex.url} component={PlanApprovalIndex} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.planApprovalCreate.url} component={PlanApprovalCreate} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.planApprovalProject.url} component={PlanApprovalProject} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.planApprovalDetail.url} component={PlanApprovalDetail} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.fatIndex.url} component={FATIndex} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.fatProject.url} component={FATProject} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.fatEdit.url} component={FATEdit} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.fatCreate.url} component={FATCreate} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.fatDetail.url} component={FATDetails} />



                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.ncrIndex.url} component={NCRIndex} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.ncrList.url} component={NCRList} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.ncrDetail.url} component={NCRDetail} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.ncrCreate.url} component={NCRCreate} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.ncrCreateComment.url} component={NCRCreateComment} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.inspectionIndex.url} component={InspectionIndex} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.inspectionProject.url} component={InspectionProject} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.inspectionCreate.url} component={InspectionCreate} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.inspectionEdit.url} component={InspectionEdit} />



                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.finalDrawingIndex.url} component={FinalDrawingIndex} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.finalDrawingDetail.url} component={FinalDrawingDetail} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createDrawing.url} component={CreateFinalDrawing} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.editDrawing.url} component={EditFinalDrawing} />




                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.activityLog.url} component={ActivityLogs} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.projectGuarantyClaimCount.url} component={ProjectGuarantyClaimCount} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.shipGuarantyClaims.url} component={ShipWisrClaimList} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.createNewGuarantyClaim.url} component={CreateGuarantyClaim} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.myAttendance.url} component={MyAttendance} />

                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.attendanceProjectList.url} component={AttendanceProject} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.attendanceCreate.url} component={CreateAttendance} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.attendanceMonthlyReport.url} component={AttendanceMonthlyReport} />
                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.attendanceMonthlyReportUser.url} component={UserAttendanceMonthlyReport} />


                <PrivateRoute exact={true} hideHeader={false} hideFooter={false} hideSidebar={false} path={constant.Authedcomponent.manual.url} component={Manual} />

                <Route exact={true} path={constant.Authedcomponent.inProgress.url} component={InProgress} />

                <Route exact={true} path={constant.Authedcomponent.logout.url} component={Logout} />
            </Switch>

        </React.Fragment>

    )
}


export default Router;

// const NonAuthedRoute = (props) => {
//     // const token = getStorage(constant.keys.userToken);
//     const token = getSessionStorage(constant.keys.userToken);
//
//     if (!token) {
//         document.body.classList.add('bg-cover-center');
//         const urlKeys = Object.entries(constant.nonAuthedcomponent);
//         const path = props.path;
//         const match = urlKeys.filter((i) => i[1].url === path);
//         if (match.length > 0 && match[0][1].url === path) {
//             return (
//                 <Route exact={true} path={props.path} component={props.component} />
//             )
//         }
//         else {
//             window.location.href = constant.nonAuthedcomponent.login.url
//         }
//     }
//     else {
//         window.location.href = constant.Authedcomponent.dashboard.url
//
//     }
//
// }
const NonAuthedRoute = ({ component: Component, ...rest }) => {
    const token = getSessionStorage(constant.keys.userToken);

    return (
        <Route
            {...rest}
            render={(props) => {
                // Not logged in → show the auth page normally
                if (!token) {
                    document.body.classList.add('bg-cover-center');
                    return <Component {...props} />;
                }

                // Logged in → redirect to dashboard, REPLACING history entry
                document.body.classList.remove('bg-cover-center');
                return (
                    <Redirect
                        to={getDefaultAuthedRoute()}
                    />
                );
            }}
        />
    );
};
// const PrivateRoute = (props) => {
//     const token = getStorage(constant.keys.userToken);
//     if (token) {
//         document.body.classList.remove('bg-cover-center');
//         const urlKeys = Object.entries(constant.Authedcomponent);
//         const path = props.path;
//         const match = urlKeys.filter((i) => i[1].url === path);
//         if (props.hideSidebar) {
//             document.body.classList.add('sidebar-enable', 'vertical-collpsed');
//         }
//         else {
//             document.body.classList.remove('sidebar-enable', 'vertical-collpsed');
//         }
//         if (props.layoutType) {
//             document.body.setAttribute("data-layout", props.layoutType);
//         }
//         if (match.length > 0 && match[0][1].url === path) {
//             return (
//                 <React.Fragment>
//                     <div id='layout-wrapper'>
//                         {!props.hideHeader && <Header
//                             sidebarStatus={props.hideSidebar ? true : false}
//                         />}
//                         {/* {<SideBar />} */}
//                         <HorizontalSideBar />
//                         <div className="main-content">
//                             {/* <Route exact={true} path={props.path} component={props.component} /> */}
//                             <Route
//                                 exact
//                                 path={props.path}
//                                 render={(routeProps) => (
//                                     <props.component {...routeProps} onlineUsers={props.onlineUsers || []} />
//                                 )}
//                             />

//                             {!props.hideFooter && <Footer />}
//                         </div>

//                     </div>

//                 </React.Fragment>
//             )
//         }
//         else {
//             window.location.href = constant.Authedcomponent.dashboard.url

//         }
//     }
//     else {
//         window.location.href = constant.nonAuthedcomponent.login.url

//     }

// }


// const PrivateRoute = (props) => {
//     // const token = getStorage(constant.keys.userToken);
//     const token = getSessionStorage(constant.keys.userToken);
//     const fetchedModules = JSON.parse(sessionStorage.getItem(constant.keys.userModule)) || btoa(JSON.stringify([]));
//     const modules = JSON.parse(atob(fetchedModules))
//
//     if (token) {
//         document.body.classList.remove('bg-cover-center');
//
//         const urlEntries = Object.entries(constant.Authedcomponent);
//         const path = props.path;
//         const matchedRoute = urlEntries.find(([key, value]) => value.url === path);
//
//         if (!matchedRoute) {
//             window.location.href = constant.Authedcomponent.dashboard.url;
//             return null;
//         }
//
//         const { permissionId } = matchedRoute[1];
//         // 🔐 Permission Check
//         const hasPermission = permissionId.length === 0 || permissionId.some(pId =>
//             modules.some(mod => mod.PERMISSION_ID === pId)
//         );
//
//         if (props.hideSidebar) {
//             document.body.classList.add('sidebar-enable', 'vertical-collpsed');
//         } else {
//             document.body.classList.remove('sidebar-enable', 'vertical-collpsed');
//         }
//
//         if (props.layoutType) {
//             document.body.setAttribute("data-layout", props.layoutType);
//         }
//
//         return (
//             <React.Fragment>
//                 {hasPermission ? (
//                     <div id='layout-wrapper'>
//                         {!props.hideHeader && (
//                             <Header sidebarStatus={props.hideSidebar || false} />
//                         )}
//                         <HorizontalSideBar />
//                         <div className="main-content">
//                             <Route
//                                 exact
//                                 path={props.path}
//                                 render={(routeProps) => (
//                                     <props.component {...routeProps} onlineUsers={props.onlineUsers || []} />
//                                 )}
//                             />
//
//                             {!props.hideFooter && <Footer />}
//                         </div>
//                     </div>
//
//                 ) : <PermissionDenied />}
//
//
//             </React.Fragment>
//         );
//     } else {
//         window.location.href = constant.nonAuthedcomponent.login.url;
//         return null;
//     }
// };
const PrivateRoute = ({ component: Component, ...rest }) => {
    const token = getSessionStorage(constant.keys.userToken);
    const fetchedModules =
        JSON.parse(sessionStorage.getItem(constant.keys.userModule)) ||
        btoa(JSON.stringify([]));
    const modules = JSON.parse(atob(fetchedModules));
    const [dashboardRoleCheck, setDashboardRoleCheck] = React.useState(() => (
        rest.denyVesselCrew ? (isVesselCrew() ? 'denied' : 'checking') : 'allowed'
    ));

    React.useEffect(() => {
        if (!rest.denyVesselCrew) {
            setDashboardRoleCheck('allowed');
            return undefined;
        }

        if (!token || isVesselCrew()) {
            setDashboardRoleCheck('denied');
            return undefined;
        }

        let active = true;
        v3_profile_detail()
            .then((response) => {
                if (!active) return;

                const encodedDetails = response?.result;
                const userDetails = encodedDetails ? JSON.parse(atob(encodedDetails)) : null;
                const isCrew = String(userDetails?.ROLE_NAME || '').trim().toLowerCase() === 'vessel crew';

                if (encodedDetails) {
                    setSessionStorage(constant.keys.userDetails, encodedDetails);
                }
                setDashboardRoleCheck(isCrew ? 'denied' : 'allowed');
            })
            .catch(() => {
                if (active) setDashboardRoleCheck('allowed');
            });

        return () => {
            active = false;
        };
    }, [token, rest.denyVesselCrew]);

    return (
        <Route
            {...rest}
            render={(routeProps) => {
                if (!token) {
                    const redirectTarget = `${routeProps.location?.pathname || ''}${routeProps.location?.search || ''}${routeProps.location?.hash || ''}`;
                    const redirectParams = new URLSearchParams();

                    if (redirectTarget) {
                        redirectParams.set('redirect', redirectTarget);
                    }

                    return (
                        <Redirect
                            to={{
                                pathname: constant.nonAuthedcomponent.login.url,
                                search: redirectParams.toString() ? `?${redirectParams.toString()}` : '',
                                state: { from: routeProps.location }
                            }}
                        />
                    );
                }

                document.body.classList.remove('bg-cover-center');

                const urlEntries = Object.entries(constant.Authedcomponent);
                const path = rest.path;
                const matchedRoute = urlEntries.find(
                    ([, value]) => value.url === path
                );

                if (!matchedRoute) {
                    return (
                        <Redirect
                            to={getDefaultAuthedRoute()}
                        />
                    );
                }

                const { permissionId = [] } = matchedRoute[1];

                if (rest.denyVesselCrew && dashboardRoleCheck === 'checking') {
                    return null;
                }

                if (rest.denyVesselCrew && dashboardRoleCheck === 'denied') {
                    return <Redirect to={getDefaultAuthedRoute()} />;
                }

                // Vessel crew do not receive the general Mail permission: the
                // mailbox API derives their access from the ship they currently
                // serve on. Let them enter only the inbox route; every mailbox
                // operation is still checked server-side against MASTER_ID /
                // CHIEF_ENGINEER, so this never exposes another vessel's mail.
                const hasCrewMailboxRouteAccess = rest.allowVesselCrew && isVesselCrew();
                const hasPermission =
                    hasCrewMailboxRouteAccess ||
                    permissionId.length === 0 ||
                    permissionId.some((pId) =>
                        modules.some((mod) => mod.PERMISSION_ID === pId)
                    );

                if (rest.hideSidebar) {
                    document.body.classList.add(
                        'sidebar-enable',
                        'vertical-collpsed'
                    );
                } else {
                    document.body.classList.remove(
                        'sidebar-enable',
                        'vertical-collpsed'
                    );
                }

                if (rest.layoutType) {
                    document.body.setAttribute(
                        'data-layout',
                        rest.layoutType
                    );
                }

                if (!hasPermission) {
                    return <PermissionDenied />;
                }

                return (
                    <React.Fragment>
                        <div id="layout-wrapper">
                            {!rest.hideHeader && (
                                <Header
                                    sidebarStatus={rest.hideSidebar || false}
                                />
                            )}
                            <HorizontalSideBar />
                            <div className="main-content">
                                <Component
                                    {...routeProps}
                                    onlineUsers={rest.onlineUsers || []}
                                />
                                {!rest.hideFooter && rest.path !== constant.Authedcomponent.sms.url && <Footer />}
                            </div>
                        </div>
                    </React.Fragment>
                );
            }}
        />
    );
};
const PrintRoute = (props) => {
    document.body.classList.remove('bg-cover-center');
    const urlKeys = Object.entries(constant.Authedcomponent);
    const path = props.path;
    const match = urlKeys.filter((i) => i[1].url === path);
    if (match.length > 0 && match[0][1].url === path) {
        return (
            <React.Fragment>
                <div id='layout-wrapper'>

                    <div className="main-content">
                        <Route exact={true} path={props.path} component={props.component} />
                    </div>

                </div>

            </React.Fragment>
        )
    }
    else {
        window.location.href = constant.Authedcomponent.dashboard.url

    }


}
